import { saveAs } from "file-saver";
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import aboutImg from "../../../img/istockphoto-1286228792-170667a-removebg-preview.png";

const About = () => {
    const saveFile = () => {
        saveAs(
          "./public/Farid_Hossain_Web_Developer_Resume.pdf",
          "Md.-Farid-Hossain-Resume.pdf"
        );
      };
    return (
        <Row xs={1} md={2} className='py-5 align-items-center' >
            <Col>
                <div className="about-img">
                    <img src={aboutImg} className='img-fluid animation' alt="" />
                </div>
            </Col>
            <Col>
                <div className="about-me">
                    <h3>ABOUT ME</h3>
                    <h2> Web Designer & Developer</h2>
                    <p> Hey!!</p>
                    <p>I am Md. Farid Hossain Jibon from Bangladesh. I always like to design something new to cope up with the world. My new ideas show me, how to be professional and to much originative. Proper activity in a work is important. That's why I always try to give more attention to my work.</p>
                    <button className=' down-btn' onClick={saveFile}>RESUME</button>
                </div>
            </Col>
        </Row>
    );
};

export default About;